import script from "./PropertySensors.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertySensors.vue?vue&type=script&setup=true&lang=js"

import "./PropertySensors.vue?vue&type=style&index=0&id=8770986e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8770986e"]])

export default __exports__